/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";

var ButtonGroupViewModel = function(params) {
	var self = this;

	self.options = params.options;
	self.value = params.value;

	self.clickedButton = function(x) {
		self.value(x);
	}
};

ko.components.register('button-group', {
	viewModel: function(params) {
		return new ButtonGroupViewModel(params);
	},
	template: require('../../../templates/shared/button-group.html')
});

export default ButtonGroupViewModel;
